// App store listings used by every "Download for iOS / Android" button.
export const IOS_APP_URL = 'https://apps.apple.com/gb/app/drive-day/id6502510746';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.drivedayapp';
